module.exports = __webpack_public_path__ + "static/media/avocado@2x.f9c30068.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/misc/src/avocado@2x.png
// module id = 560
// module chunks = 0